import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { ListSelectionDialogComponent } from "./listselection-dialog.component";
import { ListSelectionDialogService } from "./listselection-dialog.service";


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatSelectModule,
    ],

    declarations: [ListSelectionDialogComponent],
    exports: [ListSelectionDialogComponent],
    providers: [ListSelectionDialogService],
})
export class ListSelectionDialogModule {}